import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { CURRENCY_MASK_CONFIG, CurrencyMaskConfig, CurrencyMaskModule } from "ng2-currency-mask";

/*
 * Some custom configurations for the input currency. 
 */
export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "left",
  allowNegative: true,
  decimal: ",",
  precision: 2,
  prefix: "€ ",
  suffix: "",
  thousands: "."
};

/**
 * This component allow to input a monetary amount (default currency euros).
 * The 'label' input indicates what this monetary amount indicates.
 * 
 */
@Component({
  selector: 'input-monetary-amount',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
    CurrencyMaskModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputMonetaryAmountComponent),
      multi: true,
    },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
  ],
  templateUrl: './input-monetary-amount.component.html'
})
export class InputMonetaryAmountComponent implements ControlValueAccessor, OnInit {
  @Input() required = false;
  @Input() readonly = false;
  @Input() label = 'price';
  @Input() requiredLabel = 'required-price';
  @Input() formFieldClass: string = '';



  control = new FormControl<number | null>(null);

  onChange: any = () => { };
  onTouched: any = () => { };

  ngOnInit() {
    if (this.required) {
      this.control.setValidators(Validators.required);
    }
  }

  constructor() {
    this.control.valueChanges.subscribe(value => {
      this.onChange(value);
      this.onTouched();
    });
  }

  writeValue(value: number | null): void {
    this.control.setValue(value, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.control.disable() : this.control.enable();
  }
}
